let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2F69B"), load("kOWvR"), load("4Lgj0"), load("kSJiq"), load("4D7T2")]).then(() => parcelRequire('1x5LM'));